import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor() {}

  public environment = environment;

  isDevelopmentBuild() {
    return !environment.production && environment.name === 'development';
  }

  isProductionBuild() {
    return environment.production;
  }
}
